module.exports = __webpack_public_path__ + "static/media/t-rex-asteroide-inofensivo.98191524.svg";